import { useQuery } from '@tanstack/react-query';

import { api } from '@/shared/lib/apiClient';
import { useLocale } from './useLocale';

export function useCmsPage(key: string | null) {
  const locale = useLocale();
  return useQuery({
    queryKey: ['cms-page', locale, key],
    queryFn: ({ signal }) => api.pageSections.get(key!, signal),
    enabled: !!key,
    staleTime: 5 * 60_000,
    retry: (count, error) => !('code' in error && error.code === 'not_found') && count < 2,
  });
}
